import styled from 'styled-components';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getAdministrator } from 'lib/api/auth';
import useLoginCheck from 'hooks/common/useLoginCheck';
import { useMutation, useQueryClient } from 'react-query';
import { deleteAdministrator } from 'lib/api/auth';
import { VscTrash } from 'react-icons/vsc';

const Account = ({ item }) => {
  const queryClient = useQueryClient();

  const deleteAdministratorMutation = useMutation(deleteAdministrator, {
    onSuccess: () => {
      queryClient.invalidateQueries('accounts');
    },
  });
  useLoginCheck(deleteAdministratorMutation.error?.response, () => {
    deleteAdministratorMutation.mutate(item.id);
  });

  const onDelete = () => {
    deleteAdministratorMutation.mutate(item.id);
  };

  return (
    <AccountContainer>
      <div>{item.userId}</div>
      <div>{item.name}</div>
      <div>{item.tel}</div>
      <span onClick={onDelete}>
        <VscTrash />
      </span>
    </AccountContainer>
  );
};

const AccountContainer = styled.div`
  display: flex;
  padding: 10px 0px;
  border-bottom: 1px solid lightgray;
  div {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  span {
    font-size: 24px;
    cursor: pointer;
    margin-right: 15px;
  }
  & + & {
    margin-top: 15px;
  }
`;

const AccountsPage = () => {
  const navigate = useNavigate();
  const { data, error, refetch } = useQuery(['accounts'], getAdministrator);
  useLoginCheck(error?.response, refetch);
  const accountList = data?.data.adminList;

  return (
    <Container>
      <Wrapper>
        <Title>계정정보 관리</Title>
        <Button onClick={() => navigate('/admin/accountCreate')}>
          <AiOutlinePlusCircle />
        </Button>
      </Wrapper>
      <AccountWrapper>
        <Header>
          <div>아이디</div>
          <div>이름</div>
          <div>전화번호</div>
        </Header>
        {accountList?.map(item => (
          <Account item={item} key={item.id} />
        ))}
      </AccountWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  padding-right: 40px;
  margin-bottom: 20px;
  div {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: 100px;
  align-items: center;
`;

const Title = styled.div`
  font-size: 33px;
  font-weight: bold;
  letter-spacing: 4px;
`;

const Button = styled.button`
  font-size: 33px;
  background-color: transparent;
  position: relative;
  top: 3px;
  left: 100px;
  border: none;
  cursor: pointer;
`;

const AccountWrapper = styled.div`
  width: 1000px;
  border-radius: 8px;
  border: 1px solid gray;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 60px;
`;

export default AccountsPage;
